import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import {withRouter} from 'react-router-dom'
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
// import Img from './img.png'
// import firebaseApp from '../../firebase';
import { Book, Home, Phone, VideoLibrary, VpnKey } from '@material-ui/icons';
// import Img1 from './tex.jpeg';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    background:"#3f51b5"
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    [theme.breakpoints.down("xs")]:{
      flexGrow: 1,
      
    },
    color: "white",
    fontWeight: "bold"
    
  },
  headerOptions: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-evenly',
  },
}));

const Header=(props)=> {
  const { history } = props;
  const classes = useStyles();
  const [auth] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const theme= useTheme(); //checks theme variable to check what breakpoint we're currently in
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));




  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClick = (pageUrl) => {
    history.push(pageUrl);
    setAnchorEl(null);
  };
  const handleButtonClick = (pageUrl) => {
    history.push(pageUrl);
    setAnchorEl(null);
  };

  const menuItems = [
    {
      menuTitle: "Videos",
      pageUrl: "/videos"
    },
    {
      menuTitle: "Book",
      pageUrl: "/newsletter"
    },
    {
      menuTitle: "Login",
      pageUrl: "/login"
    },
  ];

  return (

      <>
      <AppBar color="primary" style={{marginTop:"0",background:"#f5f5f5",paddingTop:"0"}} position="static">
        <Toolbar style={{background:"transparent",marginBottom:"0",paddingBottom:"0"}}>
        <IconButton  edge="start" className={classes.menuButton} 
              color="inherit" aria-label="menu" 
              onClick={()=> handleButtonClick('/')}
              >
              <Typography variant="h6"  style={{color:"#D4AF37"}} className={classes.title} >
                <div style={{display:"flex"}}>
                <Home/> Home 
                </div>
            
          </Typography>
            </IconButton>    
             {isMobile?  (
               <>
              <IconButton edge="start" className={classes.menuButton} 
              color="inherit" aria-label="menu" 
              onClick={handleMenu}
              >
              <MenuIcon />
            </IconButton>
             <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={()=> setAnchorEl(null)}
              >
                {menuItems.map((menuItem)=>{
                  const {menuTitle, pageUrl} = menuItem;
                  return(
                    <MenuItem style={{color:"#D4AF37"}} onClick={()=>handleMenuClick(pageUrl)}>{menuTitle}</MenuItem>

                  );
                })}

                {/* <MenuItem onClick={()=>handleMenuClick('/images')}>Images</MenuItem>
                <MenuItem onClick={()=>handleMenuClick('/videos')}>Videos</MenuItem>
                <MenuItem onClick={()=>handleMenuClick('/newsletter')}>Newsletter</MenuItem> */}
              </Menu>
              </>
              ): 
              (
                <div className={classes.headerOptions}>
               {/* <Button style={{background:"none",border:"none",color:"#D4AF37",boxShadow:"none"}} startIcon={<Image style={{color: "#D4AF37"}} />}  variant="contained" onClick={()=> handleButtonClick('/images')} >Images</Button> */}
               <Button style={{background:"none",border:"none",color:"#D4AF37",boxShadow:"none"}} startIcon={<VideoLibrary style={{color: "#D4AF37"}} />} variant="contained" onClick={()=> handleButtonClick('/videos')} >Videos</Button>
               <Button style={{background:"none",border:"none",color:"#D4AF37",boxShadow:"none"}} startIcon={<Book style={{color: "#D4AF37"}} />}variant="contained" onClick={()=> handleButtonClick('/newsletter')} >Book</Button>
               {/* <Button style={{background:"none",border:"none",color:"#D4AF37",boxShadow:"none"}} startIcon={<Person style={{color: "#D4AF37"}} />}variant="contained" onClick={()=> handleButtonClick('/pressreleases')} >Press Releases</Button> */}
               {/* <Button style={{background:"none",border:"none",color:"#D4AF37",boxShadow:"none"}} startIcon={<Phone style={{color: "#D4AF37"}} />}variant="contained" onClick={()=> handleButtonClick('/contactus')} >Contact Us</Button> */}
               <Button style={{background:"none",border:"none",color:"#D4AF37",boxShadow:"none"}} startIcon={<VpnKey style={{color: "#D4AF37"}} />}variant="contained" onClick={()=> handleButtonClick('/login')} >Login</Button>

              </div>
              )
              
              }
            
          
        </Toolbar>
      </AppBar>
    </>
  );
}
export default withRouter(Header);
